import { render, staticRenderFns } from "./window-page-progress.vue?vue&type=template&id=dd461450&"
import script from "./window-page-progress.vue?vue&type=script&lang=js&"
export * from "./window-page-progress.vue?vue&type=script&lang=js&"
import style0 from "./window-page-progress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports